import BaseModal from '@/components/BaseModal';
import RegularText from '@/components/RegularText';
import { BREAKPOINT } from '@/constants/enum';
import { Button } from '@shopify/polaris';
import { useMediaQuery } from 'react-responsive';

interface IProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  confirmButtonText?: string;
}

const ModalConfirmLeavePage = ({ onClose, onConfirm, open, confirmButtonText }: IProps) => {
  const isMobile = useMediaQuery({ maxWidth: BREAKPOINT.SM });
  return (
    <BaseModal
      open={open}
      title={'You have unsaved changes'}
      onClose={onClose}
      footer={
        <div className="content-right" style={{ width: isMobile ? 'calc(100vw - 3rem)' : '588px' }}>
          <Button onClick={onClose}>Cancel</Button>
          <div className="ml-8">
            <Button tone="critical" variant="primary" onClick={onConfirm} id="confirm-left-btn">
              {confirmButtonText ? confirmButtonText : 'Leave page'}
            </Button>
          </div>
        </div>
      }
    >
      <RegularText>If you leave this page, all unsaved changes will be lost.</RegularText>
    </BaseModal>
  );
};

export default ModalConfirmLeavePage;
